export enum SubstitutePlan {
  RunWithSubStitute = 1,
  CancelWithSubstitute
}
